export const PAGE_TYPE = {
    MANAGE: 'manage',
    MONITORING: 'monitoring',
};

export type PageType = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];

export type FilterOption<T> = {
    label: string;
    value: string;
    slug: T[];
};
